export const tags = {
  HEB: {
    bank: {
      bankLeumi: "בנק לאומי",
      bankHapoalim: "בנק הפועלים",
      bankMizrahi: "בנק מזרחי",
      bankDiscount: "בנק דיסקונט",
      bankMercantile: "בנק מרכנתיל דיסקונט",
      bankDexia: "בנק דקסיה (דיסקונט)",
      bankFibi: "בנק הבינלאומי",
      bankMassad: "בנק מסד (הבינלאומי)",
      bankOtsar: "בנק אוצר החייל (הבינלאומי)",
      bankUbank: "בנק Ubank (הבינלאומי)",
      bankYahav: "בנק יהב",
      bankHadoar: "בנק הדואר",
      bankJerusalem: "בנק ירושלים",
      oneZero: "וואן זירו הבנק הדיגיטלי",
      citiBank: "סיטי בנק (Citibank)",
      HSBCBank: "HSBC",
      balance: 'עו"ש',
      mortgage: "משכנתה",
      foreign: 'מט"ח',
      saving: 'חיסכון(פק"מ)',
      securities: "ניירות ערך",
      loan: "הלוואה",
    },

    rsu:{
      rsu: "RSUs",
      options: "אופציות",
      espp: "ESPP",
    }, 

    share: {
      discountIsrael: "דיסקונט לישראל",
      bankHapoalim: "בנק הפועלים",
      bankYahav: "בנק יהב לעובדי מדינה",
      bankJerusalem: "בנק ירושלים",
      bankIsrael: "בנק ישראל",
      bankLeumi: "בנק לאומי לישראל",
      bankMizrahi: "בנק מזרחי טפחות",
      bankMassad: "בנק מסד",
      bankMercantile: "בנק מרכנתיל דיסקונט",
      bankFibi: "הבנק הבינלאומי הראשון לישראל",
      oneZero: "וואן זירו הבנק הדיגיטלי",
      barclaysBank: "Barclays Bank PLC",
      citiBank: "Citibank, N.A",
      HSBCBank: "HSBC Bank plc",
      xnes: "אקסלנס ניהול השקעות וניירות ערך",
      UBS: "יו.בי.אב ניירות ערך ישראל",
      meitavTrade: "מיטב טרייד",
      fairFinancials: "פייר פיננשיאל טכנולוג'יז",
      psagot: "פסגות ניירות ערך",
      IBI: "שרותי בורסה והשקעות בישראל אי.בי.אי",
      flowTradersBV: "Flow Traders B.V",
      jefferiesLLC: "Jefferies LLC",
      merrillLynch: "Merrill Lynch International",
      InteractiveIsrael: "אינטראקטיב ישראל",
      Blink: "בלינק",
    },
    debt: {
      mimunYashir: "מימון ישיר",
      isracard: "ישראכארט",
      leumicard: "דראכימואל",
      cal: "כ.א.ל",
    },
    realestate: {
      private: "נכס פרטי",
      foreignRealestate: "נדל״ן חו״ל",
      investmentFund: "קרן השקעות",
      REIT: "REIT",
      land: "קרקע",
    },
    other: {
      NFT: "NFT",
      crowdfunding: "מימון המונים",
      valuableObjects: "חפצים יקרי ערך",
      startups: "סטארטאפים",
      RSU: "RSU",
      socialLoans: "הלוואות חברתיות",
      amazonStore: "חנות אמאזון",
      land: "קרקע",
      other: "אחר",
    },
    filter: {
      displayAdditionalOptions: "הצג עוד תוצאות",
      resultsNotFound: "לא נמצאו תוצאות",
      notFoundAddManual: "אין תוצאות - המשך להוספה ידנית",
    },
    errors: {
      bank: "אנחנו עדיין לא תומכים בבנק שחיפשת... אבל ניתן להוסיף ידנית איזה בנק שרק רוצים!",
      pension:
        "אנחנו עדיין לא תומכים באפיק שחיפשת... אבל ניתן להוסיף ידנית איזה אפיק שרק רוצים!",
      share:
        "אנחנו עדיין לא תומכים בברוקר שחיפשת... אבל ניתן להוסיף ידנית איזה ברוקר שרק רוצים!",
      crypto:
        "אנחנו עדיין לא תומכים בארנק שחיפשת... אבל אפשר להוסיף ידנית איזה ארנק שרק רוצים!",
      debt: "אנחנו עדיין לא מתחברים למלווה שחיפשת... אבל ניתן להוסיף ידנית איזה מלווה שרק רוצים!",
      realestate:
        "אנחנו עדיין לא תומכים בסוג הנכס שחיפשת... אבל אפשר להוסיף ידנית איזה אפיק שרק רוצים!",
      other:
        "אנחנו עדיין לא תומכים באפיק שחיפשת... אבל ניתן להוסיף ידנית איזה אפיק שרק רוצים!",
    },
    loadMore: "טען עוד",
  },
  ENG: {
    bank: {
      bankLeumi: "Bank Leumi",
      bankHapoalim: "Bank Hapoalim",
      bankMizrahi: "Bank Mizrahi",
      bankDiscount: "Bank Discount",
      bankMercantile: "Mercantile Discount Bank",
      bankDexia: "Bank Dexia (Discount)",
      bankFibi: "First International Bank",
      bankMassad: "Bank Massad (International)",
      bankOtsar: "Bank Otsar Hahayal (International)",
      bankUbank: "Ubank (International)",
      bankYahav: "Bank Yahav",
      bankHadoar: "Israel Postal Bank",
      bankJerusalem: "Bank of Jerusalem",
      oneZero: "One Zero Digital Bank",
      citiBank: "Citibank",
      HSBCBank: "HSBC",
      balance: "Checking",
      mortgage: "Mortgage",
      foreign: "Foreign currency",
      saving: "Savings (deposit)",
      securities: "Securities",
      loan: "Loan",
    },
    rsu: {
      rsu: "RSUs",
      options: "Options",
      espp: "ESPP",
    },
    share: {
      discountIsrael: "Discount Israel",
      bankHapoalim: "Bank Hapoalim",
      bankYahav: "Bank Yahav",
      bankJerusalem: "Bank of Jerusalem",
      bankIsrael: "Bank of Israel",
      bankLeumi: "Bank Leumi",
      bankMizrahi: "Bank Mizrahi Tefahot",
      bankMassad: "Bank Massad",
      bankMercantile: "Mercantile Discount Bank",
      bankFibi: "First International Bank of Israel",
      oneZero: "One Zero Digital Bank",
      barclaysBank: "Barclays Bank PLC",
      citiBank: "Citibank, N.A",
      HSBCBank: "HSBC Bank plc",
      xnes: "Excellence Investments & Securities",
      UBS: "UBS Securities Israel",
      meitavTrade: "Meitav Trade",
      fairFinancials: "Fair Financial Technologies",
      psagot: "Psagot Securities",
      IBI: "IBI Investment House",
      flowTradersBV: "Flow Traders B.V",
      jefferiesLLC: "Jefferies LLC",
      merrillLynch: "Merrill Lynch International",
      InteractiveIsrael: "Interactive Israel",
      Blink: "Blink",
    },
    debt: {
      mimunYashir: "Mimun Yashir",
      isracard: "Isracard",
      leumicard: "Leumi Card",
      cal: "CAL",
    },
    realestate: {
      private: "Private property",
      foreignRealestate: "Foreign real estate",
      investmentFund: "Investment fund",
      REIT: "REIT",
      land: "Land",
    },
    other: {
      NFT: "NFT",
      crowdfunding: "Crowdfunding",
      valuableObjects: "Valuable objects",
      startups: "Startups",
      RSU: "RSU",
      socialLoans: "Social loans",
      amazonStore: "Amazon store",
      land: "Land",
      other: "Other",
    },
    filter: {
      displayAdditionalOptions: "Show more results",
      resultsNotFound: "No results found",
      notFoundAddManual: "No results – continue to add manually",
    },
    errors: {
      bank: "We don't support this bank yet... but you can always add it manually!",
      pension: "We don't support this option yet... but you can always add it manually!",
      share: "We don't support this broker yet... but you can always add it manually!",
      crypto: "We don't support this wallet yet... but you can always add it manually!",
      debt: "We don't support this lender yet... but you can always add it manually!",
      realestate: "We don't support this property type yet... but you can always add it manually!",
      other: "We don't support this option yet... but you can always add it manually!",
    },
    loadMore: "Load more",
  },
  RUS: {
    bank: {
      bankLeumi: "Банк Леуми",
      bankHapoalim: "Банк Апоалим",
      bankMizrahi: "Банк Мизрахи",
      bankDiscount: "Банк Дисконт",
      bankMercantile: "Меркантиль Дисконт Банк",
      bankDexia: "Банк Дексия (Дисконт)",
      bankFibi: "Первый международный банк",
      bankMassad: "Банк Масад (Международный)",
      bankOtsar: "Банк Оцар Ахаяль (Международный)",
      bankUbank: "Ubank (Международный)",
      bankYahav: "Банк Яхав",
      bankHadoar: "Почтовый банк Израиля",
      bankJerusalem: "Банк Иерусалима",
      oneZero: "One Zero Цифровой банк",
      citiBank: "Citibank",
      HSBCBank: "HSBC",
      balance: "Текущий счёт",
      mortgage: "Ипотека",
      foreign: "Иностранная валюта",
      saving: "Сбережения (депозит)",
      securities: "Ценные бумаги",
      loan: "Кредит",
    },
    rsu: {
      rsu: "RSUs",
      options: "Опционы",
      espp: "ESPP",
    },
    share: {
      discountIsrael: "Дисконт Израиль",
      bankHapoalim: "Банк Апоалим",
      bankYahav: "Банк Яхав",
      bankJerusalem: "Банк Иерусалима",
      bankIsrael: "Банк Израиля",
      bankLeumi: "Банк Леуми",
      bankMizrahi: "Банк Мизрахи Тфахот",
      bankMassad: "Банк Масад",
      bankMercantile: "Меркантиль Дисконт Банк",
      bankFibi: "Первый международный банк Израиля",
      oneZero: "One Zero Цифровой банк",
      barclaysBank: "Barclays Bank PLC",
      citiBank: "Citibank, N.A",
      HSBCBank: "HSBC Bank plc",
      xnes: "Excellence Investments & Securities",
      UBS: "UBS Securities Israel",
      meitavTrade: "Мейтав Трейд",
      fairFinancials: "Fair Financial Technologies",
      psagot: "Псагот Секьюритиз",
      IBI: "IBI Investment House",
      flowTradersBV: "Flow Traders B.V",
      jefferiesLLC: "Jefferies LLC",
      merrillLynch: "Merrill Lynch International",
      InteractiveIsrael: "Interactive Israel",
      Blink: "Blink",
    },
    debt: {
      mimunYashir: "Мимун Яшир",
      isracard: "Исракарт",
      leumicard: "Леуми Кард",
      cal: "CAL",
    },
    realestate: {
      private: "Частная собственность",
      foreignRealestate: "Зарубежная недвижимость",
      investmentFund: "Инвестиционный фонд",
      REIT: "REIT",
      land: "Земля",
    },
    other: {
      NFT: "NFT",
      crowdfunding: "Краудфандинг",
      valuableObjects: "Ценные предметы",
      startups: "Стартапы",
      RSU: "RSU",
      socialLoans: "Социальные займы",
      amazonStore: "Магазин Amazon",
      land: "Земля",
      other: "Прочее",
    },
    filter: {
      displayAdditionalOptions: "Показать ещё результаты",
      resultsNotFound: "Результаты не найдены",
      notFoundAddManual: "Нет результатов — продолжить добавление вручную",
    },
    errors: {
      bank: "Мы пока не поддерживаем этот банк... но вы всегда можете добавить его вручную!",
      pension: "Мы пока не поддерживаем этот продукт... но вы всегда можете добавить его вручную!",
      share: "Мы пока не поддерживаем этого брокера... но вы всегда можете добавить его вручную!",
      crypto: "Мы пока не поддерживаем этот кошелёк... но вы всегда можете добавить его вручную!",
      debt: "Мы пока не поддерживаем этого кредитора... но вы всегда можете добавить его вручную!",
      realestate: "Мы пока не поддерживаем этот тип недвижимости... но вы всегда можете добавить его вручную!",
      other: "Мы пока не поддерживаем этот продукт... но вы всегда можете добавить его вручную!",
    },
    loadMore: "Загрузить ещё",
  },
};
